/* eslint-disable max-len */

import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  svgStyles?: string
}

const LogoutSvg = (props: Props): JSX.Element => {
  const { svgStyles, ...rest } = props

  const img = `
    <svg class="${
      props.svgStyles ?? ''
    }" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 32 32">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_874" data-name="Rectangle 874" width="19.15" height="20.191" fill="none" stroke="#3682ce" stroke-linecap="round" stroke-width="1"/>
        </clipPath>
      </defs>
      <g id="Group_3437" data-name="Group 3437" transform="translate(-32 -752)">
        <rect id="Rectangle_876" data-name="Rectangle 876" width="32" height="32" transform="translate(32 752)" fill="none"/>
        <g id="Group_3436" data-name="Group 3436" transform="translate(38 758)" clip-path="url(#clip-path)">
          <line id="Line_280" data-name="Line 280" x1="4.532" y1="4.532" transform="translate(0.748 10.095)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
          <line id="Line_281" data-name="Line 281" x2="11.536" transform="translate(0.767 10.095)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
          <line id="Line_282" data-name="Line 282" x1="4.532" y2="4.532" transform="translate(0.748 5.564)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
          <path id="Path_1957" data-name="Path 1957" d="M332.174,40h12.193V58.7H332.174" transform="translate(-325.964 -39.252)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        </g>
      </g>
    </svg>

  `
  return <div {...rest} dangerouslySetInnerHTML={{ __html: img }} />
}

export default LogoutSvg
